<template>
    <b-jumbotron class="py-5">
        <h2 class="text-center mb-4">
            {{ homePageActiveCareer }}
            <b-button
                v-if="isUserAdmin"
                variant="primary"
                class="mx-2"
                :to="{ name: 'admin-courses-create' }"
            >
                <b-icon-plus /> Agregar asignatura
            </b-button>
        </h2>

        <b-tabs
            active-nav-item-class="bg-primary text-white"
            nav-wrapper-class="py-4"
            fill
        >
            <b-tab
                title="Obligatorias"
                active
                :title-link-class="bTabLinkClasses"
            >
                <div
                    v-for="(courses, semester) in getCoursesBySemester"
                    :key="semester"
                >
                    <div v-if="courses.length && semester !== 'Electivas'">
                        <h4>{{ semester }}</h4>
                        <b-table
                            fixed
                            hover
                            :items="courses"
                            :fields="coursesFields"
                            :sort-by="'name'"
                            :sort-desc="false"
                        >
                            <template v-slot:cell(name)="data">
                                <a @click.prevent="goToLatestCourseSite(data.item)" href="#">{{ data.value }}</a>
                            </template>
                            <template v-slot:cell(academic_period)="data">
                                <span v-if="data.item.sites.length">
                                    {{ data.item.sites[data.item.sites.length-1].semester.academic_period }}
                                </span>
                                <span v-else>No posee</span>
                            </template>
                            <template v-if="isUserTeachingStaff" v-slot:cell(actions)="data">
                                <div class="text-center">
                                    <b-button
                                        variant="primary"
                                        size="sm"
                                        @click="onCreateNewSite(data.item)"
                                    >
                                        <b-icon-plus />
                                    </b-button>
                                </div>
                            </template>
                        </b-table>
                        <hr>
                    </div>
                </div>
                <hr>
            </b-tab>
            <b-tab
                title="Electivas"
                :title-link-class="bTabLinkClasses"
            >
                <div v-if="getElectiveCoursesBySemester && getElectiveCoursesBySemester.length">
                    <b-table
                        fixed
                        hover
                        :items="getElectiveCoursesBySemester"
                        :fields="coursesFields"
                        :sort-by="'name'"
                        :sort-desc="false"
                    >
                        <template v-slot:cell(name)="data">
                            <a @click.prevent="goToLatestCourseSite(data.item)" href="#">{{ data.value }}</a>
                        </template>
                        <template v-slot:cell(academic_period)="data">
                            <span v-if="data.item.sites.length">
                                {{ data.item.sites[data.item.sites.length-1].semester.academic_period }}
                            </span>
                            <span v-else>No posee</span>
                        </template>
                        <template v-if="isUserTeachingStaff" v-slot:cell(actions)="data">
                            <div class="text-center">
                                <b-button
                                    variant="primary"
                                    size="sm"
                                    @click="onCreateNewSite(data.item)"
                                >
                                    <b-icon-plus />
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                </div>
                <div v-else>
                    <h4 class="text-center pt-5">No hay asignaturas electivas registradas para esta licenciatura.</h4>
                </div>
            </b-tab>
            <b-tab
                title="Cursos"
                :title-link-class="bTabLinkClasses"
            >
                <div v-if="getOtherCoursesBySemester && getOtherCoursesBySemester.length">
                    <b-table
                        fixed
                        hover
                        :items="getOtherCoursesBySemester"
                        :fields="otherCoursesFields"
                        :sort-by="'name'"
                        :sort-desc="false"
                    >
                        <template v-slot:cell(name)="data">
                            <a @click.prevent="goToLatestCourseSite(data.item)" href="#">{{ data.value }}</a>
                        </template>
                        <template v-slot:cell(academic_period)="data">
                            <span v-if="data.item.sites.length">
                                {{ data.item.sites[data.item.sites.length-1].semester.academic_period }}
                            </span>
                            <span v-else>No posee</span>
                        </template>
                        <template v-if="isUserTeachingStaff" v-slot:cell(actions)="data">
                            <div class="text-center">
                                <b-button
                                    variant="primary"
                                    size="sm"
                                    @click="onCreateNewSite(data.item)"
                                >
                                    <b-icon-plus />
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                </div>
                <div v-else>
                    <h4 class="text-center pt-5">No hay otras asignaturas registradas para esta licenciatura.</h4>
                </div>
            </b-tab>
        </b-tabs>

    </b-jumbotron>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'HomeCoursesList',
    data () {
        return {
            bTabLinkClasses: ['px-2', 'py-3'],
            selectedCourse: null // Used for displaying the create site modal.
        }
    },
    computed: {
        ...mapState([
            'homePageActiveCareer'
        ]),
        ...mapGetters([
            'getHomePageFormattedCourses',
            'isUserTeachingStaff',
            'isUserAdmin'
        ]),
        coursesFields () {
            var fields = [
                { key: 'name', label: 'Nombre', class: 'w-55' },
                { key: 'code', label: 'Código', class: 'text-center' },
                { key: 'credit_units', label: 'UC', class: 'text-center' },
                { key: 'academic_period', label: 'Último período', class: 'text-center' }
            ]
            if (this.isUserTeachingStaff) {
                fields.push({ key: 'actions', label: 'Crear Sitio', class: 'text-center' })
            }
            return fields
        },
        otherCoursesFields () {
            var fields = [
                { key: 'name', label: 'Nombre', class: 'w-55' },
                { key: 'academic_period', label: 'Último período', class: 'text-center' }
            ]
            if (this.isUserTeachingStaff) {
                fields.push({ key: 'actions', label: 'Crear Sitio', class: 'text-center' })
            }
            return fields
        },
        getCoursesBySemester () {
            if (!this.getHomePageFormattedCourses) {
                return null
            }
            return this.getHomePageFormattedCourses[this.homePageActiveCareer]
        },
        getElectiveCoursesBySemester () {
            if (!this.getHomePageFormattedCourses) {
                return null
            }
            return this.getHomePageFormattedCourses[this.homePageActiveCareer]['Electivas']
        },
        getOtherCoursesBySemester () {
            if (!this.getHomePageFormattedCourses) {
                return null
            }
            return this.getHomePageFormattedCourses[this.homePageActiveCareer]['Otra']
        }
    },
    methods: {
        goToLatestCourseSite (course) {
            if (course.sites.length) {
                // Nagivate to the latests site for the chosen course
                var academicPeriod = course.sites[course.sites.length - 1].semester.academic_period
                this.$router.push({ name: 'site', params: { courseCode: course.code, academicPeriod: academicPeriod } })
            } else {
                this.warningToast(`La asignatura ${course.name} no posee sitio asociado.`, 'No posee sitio.')
            }
        },
        onCreateNewSite (course) {
            this.$router.push({ name: 'create-site', params: { courseCode: course.code } })
        }
    }
}
</script>
